/* tpw-pod-home odometer (3 Nov 2026). Own code. Builds digit reels only after seeing the readings below the fold, rolls them once on first sight, then collapses to the real digits. See sections/tpw-pod-home.liquid. */
(function () {
  var rd = document.querySelectorAll('.tph-read:not([data-tph-roll])');
  if (!rd.length || !('IntersectionObserver' in window) || !window.matchMedia) return;
  var mq = matchMedia('(prefers-reduced-motion: reduce)');
  if (mq.matches) return;
  function end(el) {
    el.setAttribute('data-tph-roll', 'done');
    [].forEach.call(el.querySelectorAll('.tph-d'), function (d) { var w = d.firstChild; w.textContent = w.textContent.slice(-1); d.style.setProperty('--t', 0); });
  }
  function each(sel, f) { [].forEach.call(document.querySelectorAll('.tph-read' + sel), f); }
  function build(el) {
    var n = 0;
    [].forEach.call(el.querySelectorAll('[data-tph-v]'), function (v, g) {
      var t = v.textContent.trim();
      if (!/^\d{1,6}$/.test(t)) return;
      var h = '<span class="tph-sr">' + t + '</span><span class="tph-rl" aria-hidden="true">';
      for (var i = 0; i < t.length; i++) {
        var d = +t[i], s = '';
        for (var k = 0; k < d + 11; k++) s += (k ? '\n' : '') + (k % 10);
        h += '<span class="tph-d" style="--g:' + g + ';--i:' + i + ';--t:' + (d + 10) + '"><span class="tph-w">' + s + '</span></span>';
      }
      v.innerHTML = h + '</span>';
      n++;
    });
    return n;
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var el = e.target, st = el.getAttribute('data-tph-roll');
      if (!st) {
        if (e.isIntersecting) return io.unobserve(el);
        if (build(el)) el.setAttribute('data-tph-roll', 'park'); else io.unobserve(el);
      } else if (st === 'park' && e.isIntersecting) {
        io.unobserve(el);
        el.setAttribute('data-tph-roll', 'go');
        setTimeout(function () { end(el); }, 1500);
      }
    });
  });
  [].forEach.call(rd, function (el) { io.observe(el); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) each('[data-tph-roll=go]', end); });
  addEventListener('pageshow', function (e) { if (e.persisted) each('[data-tph-roll]', end); });
  if (mq.addEventListener) mq.addEventListener('change', function () { if (mq.matches) each('[data-tph-roll]', end); });
})();
